import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useEffect, useState } from "react";
import { haveValue, isDefaultWorkspace } from "../../helper/common";
import LoadingSpinner from "../LoadingSpinner";
import { FaCamera } from "react-icons/fa6";
import { toast } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import ConfirmWorkspaceRemovalModal from "./ConfirmWorkspaceRemovalModal";
import ManageMembersModal from "./ManageMembersModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import InvitationsCustomization from "./InvitationsCustomization";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";
import NotificationCustomization from "./NotificationCustomization";

const CreateNewWorkspaceModal = (props) => {
  const {
    workspaceTab = "settings",
    changeWorkspaceTab,
    isOpen,
    onClose,
    workspace = null,
    setOpenWorkspaceModal,
    // setOpenInviteModal = false,
    setOpenInvitationCustomization = false,
    setWorkspaceName,
    workspaceName,
    actionType = "add",
    // handleSubmitEdit,
    // isModalButtonLoading,
    setWorkspaceImage,
    manageMembers,
    goToPrevStep,
    goToStepFive,
    currentStep,
  } = props;
  const { _t } = useTranslator();
  const { loadUserTenant, user } = useContext(AuthContext);
  const { updateWorkspace, getWorkspaceMemberData } =
    useContext(LandLordContext);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [selectedAvatarIndex, setSelectedAvatarIndex] = useState(null);
  const [editWorkspaceName, setEditWorkspaceName] = useState(workspace?.name);
  // Stores uploaded image preview URL
  const [uploadedImage, setUploadedImage] = useState(null);
  const [workspaceMemberInfo, setWorkspaceMemberInfo] = useState({});
  const [memberLoading, setMemberLoading] = useState(false);
  // Stores actual uploaded file (for backend)
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isModalButtonLoading, setIsModalButtonLoading] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isInputDropdown, setIsInputDropdown] = useState(false);

  useEffect(() => {
    if (actionType == "edit") {
      setEditWorkspaceName(workspace?.name);
    }
  }, [actionType]);

  useEffect(() => {
    loadMembersData();
  }, []);

  const loadMembersData = async () => {
    try {
      setMemberLoading(true);
      const memberData = await getWorkspaceMemberData();
      setWorkspaceMemberInfo(memberData);
    } catch (error) {
      setWorkspaceMemberInfo({});
    } finally {
      setMemberLoading(false);
    }
  };

  const handleInputChange = (e) => {
    let value = e.target.value;

    // Prevent space as first character
    value = value.replace(/^\s+/, "");

    if (actionType == "edit") {
      setEditWorkspaceName(value);
    } else {
      setWorkspaceName(value);
    }
  };

  const handleNextStep = () => {
    if (haveValue(selectedAvatarIndex)) {
      setWorkspaceImage({ selectedAvatarIndex: selectedAvatarIndex });
    } else if (haveValue(uploadedFile)) {
      setWorkspaceImage({ uploadedFile: uploadedFile });
    }

    // setOpenInviteModal(true);
    setOpenInvitationCustomization(true);
    setOpenWorkspaceModal(false);
  };

  useEffect(() => {
    if (currentStep === 5) {
      console.log("inside", currentStep);
      handleNextStep();
      goToStepFive();
    }
  }, [currentStep]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadedFile(file);
    setUploadedImage(URL.createObjectURL(file));
    setSelectedAvatarIndex(null);
    if (actionType == "edit") {
      handleSubmitEdit(null, null, file, false, false);
    }
  };
  const handleDefaultImage = () => {
    setSelectedAvatarIndex(null);
    setUploadedImage(null);
    setUploadedFile(null);
    if (actionType == "edit") {
      handleSubmitEdit(null, null, null, true, false);
    }
  };
  const handleAvatarSelect = (index) => {
    setSelectedAvatarIndex(index);
    setUploadedImage(null);
    setUploadedFile(null);
    if (actionType == "edit") {
      handleSubmitEdit(null, index, null, false, false);
    }
  };

  const handleSubmitEdit = async (
    event,
    index = null,
    fileUpload = null,
    isEmpty = false,
    isTextLoading = true
  ) => {
    try {
      setIsImageLoading(true);
      const tempData = {
        name: editWorkspaceName,
      };
      const formData = new FormData();
      formData.append("name", editWorkspaceName);
      if (haveValue(index)) {
        console.log("Inside index");
        formData.append("imageUrl", `DefaultWorkspace${index}.png`);
      } else if (haveValue(fileUpload)) {
        console.log("Inside fileUpload");
        formData.append("profileImage", fileUpload);
      } else if (isEmpty) {
        console.log("Inside  isEmpty");
        formData.append("imageUrl", null);
      } else {
        formData.append("imageUrl", workspace?.workspaceImage);
      }
      setIsModalButtonLoading(true);
      await updateWorkspace(formData);
      toast.success(_t("workspaceUpdatedSuccessfully"));
      setEditWorkspaceName(tempData?.name);
      await loadUserTenant("landlord");
    } catch (err) {
      console.log(err);

      toast.error(_t("errorWhileUpdatingWorkspace"));
    } finally {
      setIsModalButtonLoading(false);
      setIsImageLoading(false);
    }
  };

  return (
    <div onClick={() => setIsInputDropdown(false)}>
      <Modal
        show={isOpen}
        onHide={() => {
          onClose();
          goToPrevStep?.();
        }}
        centered
        id="manage-member-walkthrough"
        className="newmodalui max-w-lg tailwind-base-modal wrapper-modal newWorkspaceModal manageWorkspaceModalWrapper"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {actionType == "add"
              ? _t("createNewWorkspace")
              : _t("manageWorkspace")}
          </Modal.Title>
          {actionType == "edit" &&
            WORKSPACE_ROLES_CAPABILITIES?.deleteWorkspace?.includes(
              user?.current_workspace_role
            ) &&
            !isDefaultWorkspace(user) && (
              <div
                onClick={(e) => setOpenDeleteModal(true)}
                className="delete-icon cursor-pointer"
              >
                <img src="/images/delete-icon.svg" />
              </div>
            )}
        </Modal.Header>
        {actionType == "edit" &&
          WORKSPACE_ROLES_CAPABILITIES?.manageWorkspace?.includes(
            user?.current_workspace_role
          ) && (
            <div className="workspace-tab-toggle">
              <div
                className={`workspace-tab-label ${
                  workspaceTab === "settings" ? "active" : ""
                }`}
                onClick={() => changeWorkspaceTab("settings")}
              >
                {_t("settings")}
              </div>

              <div
                className={`workspace-tab-label ${
                  workspaceTab === "members" ? "active" : ""
                }`}
                onClick={() => changeWorkspaceTab("members")}
              >
                {_t("members")}
              </div>

              {WORKSPACE_ROLES_CAPABILITIES?.editInvitationLink?.includes(
                user?.current_workspace_role
              ) && (
                <div
                  className={`workspace-tab-label ${
                    workspaceTab === "invitations" ? "active" : ""
                  }`}
                  onClick={() => changeWorkspaceTab("invitations")}
                >
                  {_t("invitations")}
                </div>
              )}

              {WORKSPACE_ROLES_CAPABILITIES?.viewNotifications?.includes(
                user?.current_workspace_role
              ) && (
                <div
                  className={`workspace-tab-label ${
                    workspaceTab === "notifications" ? "active" : ""
                  }`}
                  onClick={() => changeWorkspaceTab("notifications")}
                >
                  {_t("notifications")}
                </div>
              )}
            </div>
          )}
        {workspaceTab === "settings" ? (
          <>
            <Modal.Body>
              {actionType == "add" && (
                <p className="text-center mb-4">
                  {_t("createYourNewSharedWorkspaceWithLandlords")}
                </p>
              )}

              <div className="outer-label">
                <label>{_t("workspaceName")}</label>
                <div className="main-form-group form-group-wrapper">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder={_t("enterWorkspaceName")}
                      onChange={handleInputChange}
                      value={
                        actionType == "edit" ? editWorkspaceName : workspaceName
                      }
                      name="name"
                      required
                    />
                  </div>
                </div>
              </div>
              <p className="company-name-text">
                {_t("youCanUseYourOrganizationOrCompanyNameKeepItSimple")}
              </p>
              {/* <p className="set-workspace-profile-text">
                {_t("setWorkspaceProfileImageOrChooseAnIcon")}
              </p> */}
              <div className="manage-workspace-modal">
                <div className="modal-content w-100 m-0 p-0">
                  <div
                    className="edit-workspace pb-0"
                    style={{
                      boxShadow: "none",
                      paddingLeft: "0",
                      paddingRight: "0",
                    }}
                  >
                    <h4 className="profile-picture-heading">
                      {_t("profilePicture")}
                    </h4>
                    {/* ================= Upload / Preview Section ================= */}
                    <div className="d-flex predefined-avatar-wrapper">
                      <div
                        className={`upload-logo flex-shrink-0 ${
                          isImageLoading && "align-items-center"
                        }`}
                        style={{
                          backgroundColor:
                            uploadedImage ||
                            uploadedFile ||
                            haveValue(workspace?.workspaceImage)
                              ? "transparent"
                              : actionType === "add"
                                ? "transparent"
                                : "#E5FBCE", // fallback color
                        }}
                      >
                        {isImageLoading ? (
                          <LoadingSpinner
                            size={"2.4722vw"}
                            color="#253837"
                            borderWidth={1}
                            className={"docs-loading-spinner"}
                          />
                        ) : uploadedImage ? (
                          <img
                            src={uploadedImage}
                            alt="Uploaded workspace logo"
                            className="workspace-preview-image"
                          />
                        ) : selectedAvatarIndex !== null ? (
                          <img
                            src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/DefaultWorkspace${selectedAvatarIndex}.png`}
                            alt="Selected avatar"
                            className="workspace-preview-image"
                          />
                        ) : actionType == "add" ? (
                          <img
                            src="/images/default-img.svg"
                            alt="Uploaded workspace logo"
                            className="workspace-preview-image workshop-default-image"
                          />
                        ) : haveValue(workspace?.workspaceImage) ? (
                          <img
                            src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${workspace?.workspaceImage}`}
                            alt="Selected avatar"
                            className="workspace-preview-image"
                          />
                        ) : (
                          <h1>{workspace?.name?.substring(0, 1)}</h1>
                        )}

                        <label className="upload-logo-icon cursor-pointer">
                          <FaCamera size={14} />
                          <span>{_t("uploadLogo")}</span>
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={handleImageUpload}
                          />
                        </label>
                      </div>

                      {/* ================= Predefined Avatars ================= */}
                      <div className="workspace-avtar mb-0">
                        <p className="company-name-text">
                          {_t(
                            "uploadAnImageOrPickAnEmojiForProfilePictureItWillShowUpInSidebarAndNotification"
                          )}
                        </p>
                        <div className="d-flex align-items-center w-100 flex-wrap">
                          {actionType == "edit" && (
                            <div
                              className={`workspace-avatar-active ${
                                !haveValue(selectedAvatarIndex) &&
                                !haveValue(uploadedFile) &&
                                !haveValue(workspace?.workspaceImage)
                                  ? "border-active"
                                  : ""
                              }`}
                            >
                              <div
                                className={`name-avatar cursor-pointer`}
                                onClick={() => handleDefaultImage()}
                              >
                                {workspace?.name?.substring(0, 1)}
                              </div>
                            </div>
                          )}
                          {[1, 2, 3, 4, 5, 6, 7].map((index) => (
                            <div
                              key={index}
                              className={`avatar-item cursor-pointer workspace-avatar-active ${
                                selectedAvatarIndex === index
                                  ? "border-active"
                                  : ""
                              }`}
                              onClick={() => handleAvatarSelect(index)}
                            >
                              <img
                                src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/DefaultWorkspace${index}.png`}
                                alt={`Default avatar ${index}`}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <div className="inviteButtonWrapper">
              {/* <button
                type="button"
                className="btnNext btnnextpre"
              >
                {_t("discardChanges")}
              </button> */}
              <div
                data-tooltip-id="button-action-tooltip"
                style={{ display: "inline-block" }}
              >
                <button
                  type="button"
                  disabled={
                    (!haveValue(workspaceName) &&
                      !haveValue(editWorkspaceName)) ||
                    isModalButtonLoading
                  }
                  className="btnNext basicInfoButton greenHover"
                  onClick={
                    actionType === "add"
                      ? () => {
                          handleNextStep();
                          goToStepFive?.();
                        }
                      : handleSubmitEdit
                  }
                >
                  {_t("continue")}
                </button>
                {((!haveValue(workspaceName) &&
                  !haveValue(editWorkspaceName)) ||
                  isModalButtonLoading) && <ButtonActionTooltip />}
              </div>
            </div>
          </>
        ) : workspaceTab === "invitations" ? (
          <InvitationsCustomization
            workspaceData={workspace}
            onClose={onClose}
          />
        ) : workspaceTab === "notifications" ? (
          <NotificationCustomization
            workspaceMemberInfo={workspaceMemberInfo}
            memberLoading={memberLoading}
            loadMembersData={loadMembersData}
          />
        ) : (
          <ManageMembersModal
            manageMembers={manageMembers}
            isInputDropdown={isInputDropdown}
            setIsInputDropdown={setIsInputDropdown}
          />
        )}
      </Modal>
      {openDeleteModal && (
        <ConfirmWorkspaceRemovalModal
          setOpenDeleteModal={setOpenDeleteModal}
          onCloseMain={onClose}
        />
      )}
    </div>
  );
};

export default CreateNewWorkspaceModal;
